import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import ppOnePagerUrl from "../assets/pp-one-pager.pdf?url";
import ppPopupUrl from "../assets/pp-popup.png?url";
import { OnboardingProps } from "../common";

export const PackageProtectionPlusOnboarding = memo(
  function PackageProtectionPlusOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const handleAction = () => {
      window.open(ppOnePagerUrl, "_blank");
      handleComplete();
    };

    return (
      <RedoFeatureNotificationCard
        actionText="Learn more"
        description="Tired of managing your claims? Let us handle it for you!"
        image={ppPopupUrl}
        onAction={handleAction}
        onDismiss={handleDismiss}
        title="Package Protection+"
      />
    );
  },
);
